import type { FlowTask } from '@Types/FlowTask.interface';
import  { EsignatureFlowType } from '@Enums/esignatureFlowType.enum';
import _ from 'lodash';

// TODO: Example file, customeize it and rename file to match your flow

// TODO: Create your own flow definitions
// Create a flow type for each expected page in app returned by the client flows.
// The 
// TIP: 
export const FLOW_DEFINITIONS: Record<EsignatureFlowType, FlowTask[]> = {
    [EsignatureFlowType.ReviewDocument]: [
        { routeName: "review" },
    ],
    [EsignatureFlowType.EnvelopeView]: [
        {
            routeName: 'envelope',
        },
    ],
    [EsignatureFlowType.EsignatureComplete]: [
        {
            routeName: 'complete',
        },
    ],
    [EsignatureFlowType.Dashboard]: [
        {
            routeName: 'dashboard',
        },
    ],
};


export const isFeatureFlowType = (val: string): val is EsignatureFlowType => {
    return _.includes(_.values(EsignatureFlowType), val);
};